module.exports = __webpack_public_path__ + "static/media/23_A.576dcc61.png";